import { LegacyIconButton } from '~/components/ui/LegacyIconButton';
import { commandStore } from '~/lib/stores/command';
import { classNames } from '~/utils/classNames';

function Container({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="overflow-hidden grid h-80"
      style={{
        gridTemplateAreas: `
          "header"
          "content"
          "footer"
        `,
        gridTemplateRows: 'auto 1fr auto',
        maxHeight: 'calc(var(--radix-popper-available-height) - 16px)',
      }}
    >
      {children}
    </div>
  );
}

function Content({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div style={{ gridArea: 'content' }} className={classNames('overflow-y-auto', className)}>
      {children}
    </div>
  );
}

function Header({ title, description }: { title: string; description?: string }) {
  return (
    <div
      style={{ gridArea: 'header' }}
      className="flex items-center gap-2 px-3 py-3 rounded-t-lg border-b border-bolt-elements-borderColor"
    >
      <LegacyIconButton onClick={() => commandStore.router.pop()} tabIndex={-1}>
        <span className="i-lucide:chevron-left size-4" />
      </LegacyIconButton>

      <h2 className="text-sm font-medium">{title}</h2>

      {description && (
        <>
          <span className="rounded mx-1 w-0.5 h-2.5 shrink-0 bg-bolt-ds-borderDivider" />
          <p className="text-xs text-bolt-elements-textSecondary">{description}</p>
        </>
      )}
    </div>
  );
}

function Footer({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{ gridArea: 'footer' }}
      className="flex items-center justify-end gap-2 bg-bolt-elements-background-depth-3 p-1 rounded-b-lg relative border-t border-bolt-elements-borderColor"
    >
      {children}
    </div>
  );
}

function FooterTitle({ title }: { title: string }) {
  if (!title) {
    return null;
  }

  return (
    <>
      <div className="text-xs font-medium text-bolt-elements-textSecondary pl-2">{title}</div>
      <div className="flex-1"></div>
    </>
  );
}

const View = {
  Container,
  Content,
  Header,
  Footer,
  FooterTitle,
};

export default View;
